'use es6';

import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import { PureComponent } from 'react';
import { AsyncComponentErrorHandler } from 'ContentEditorUI/components/lameErrorHandling';
import ErrorPanel from '../components/sidebarPanels/Error';
import { AsyncComponentReload } from 'ContentEditorUI/components/shared/makeAsyncUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export function withErrorBoundary(WrappedComponent, isFromIframe = false, errorComponent, metricsReporting) {
  class HOCWithErrorBoundary extends PureComponent {
    render() {
      const _this$props = this.props,
        wrappedComponentProps = Object.assign({}, (_objectDestructuringEmpty(_this$props), _this$props));
      return /*#__PURE__*/_jsx(AsyncComponentErrorHandler, {
        isFromIframe: isFromIframe,
        errorComponent: errorComponent,
        metricsReporting: metricsReporting,
        children: /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, wrappedComponentProps))
      });
    }
  }
  return HOCWithErrorBoundary;
}
export function ModuleRenderError() {
  return /*#__PURE__*/_jsx(AsyncComponentReload, {});
}
export function withErrorBoundaryConnect(isFromIframe = false, errorComponent, metricsReporting) {
  return function (WrappedComponent) {
    return withErrorBoundary(WrappedComponent, isFromIframe, errorComponent, metricsReporting);
  };
}
export function withPanelErrorBoundary(WrappedComponent, isFromIframe = true) {
  class HOCWithErrorBoundary extends PureComponent {
    render() {
      const _this$props2 = this.props,
        wrappedComponentProps = Object.assign({}, (_objectDestructuringEmpty(_this$props2), _this$props2));
      return /*#__PURE__*/_jsx(AsyncComponentErrorHandler, {
        errorComponent: /*#__PURE__*/_jsx(ErrorPanel, {}),
        isFromIframe: isFromIframe,
        children: /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, wrappedComponentProps))
      });
    }
  }
  return HOCWithErrorBoundary;
}